import cookie from 'js-cookie';
import get from 'lodash/get';

export const USER_ID = 'user';
export const DEFAULT_VALUE = {};

export const USER_STORAGE_KEY_MAP = {
  contact_name: 'contact_name',
  phone: 'phone',
  email: 'email',
  company_name: 'company_name',
  company_size: 'company_size',
  desiredCapacity: 'desired_capacity',
  capacity: 'desired_capacity',
  date: 'moveInDate',
  moveInDate: 'moveInDate',
  startDateFilter: 'startDateFilter', // this hold an ISO date instead of the 'This month' string
  bbox: 'bbox', // used in the search page to preserve last map location
  commitmentLength: 'commitmentLength',
  monthlyPrice: 'monthlyPrice',
  totalMonthlyCost: 'totalMonthlyCost',
  cbpDiscount: 'cbpDiscount',
  cbpDiscountPercentage: 'cbpDiscountPercentage',
  currency: 'currency',
  cart: 'cart',
  notification: 'notification',
  reservableMoveInDate: 'reservableMoveInDate'
};

const isSecureCookie = get(window, 'clientSideInjectionVars.isProd', false);
const cookieOptions = { sameSite: 'Lax', secure: isSecureCookie };

export default class User {
  // cookies is an optional argument to be used when trying to access values from the server (i.e. req.cookies)
  static get(cookies) {
    if (cookies) {
      return (cookies && JSON.parse(cookies[USER_ID] || null)) || DEFAULT_VALUE;
    }

    return cookie.getJSON(USER_ID) || DEFAULT_VALUE;
  }

  static getValue(key, cookies) {
    return this.get(cookies)[key];
  }

  static saveValue(key, value) {
    const user = this.get();
    user[key] = value;
    cookie.set(USER_ID, user, cookieOptions);
  }

  static clearValue(key) {
    this.saveValue(key, '');
  }

  static saveValues(keyValueMap) {
    const user = { ...this.get(), ...keyValueMap };
    cookie.set(USER_ID, user, cookieOptions);
  }

  static reset() {
    cookie.set(USER_ID, DEFAULT_VALUE, cookieOptions);
  }
}
